
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { FormLabel } from '@/components/ui/form';
import { Plus, X } from 'lucide-react';
import { toast } from 'sonner';

interface SizeVariant {
  id: string;
  name: string;
}

interface SizeVariantsSectionProps {
  sizes: SizeVariant[];
  setSizes: React.Dispatch<React.SetStateAction<SizeVariant[]>>;
}

const SizeVariantsSection: React.FC<SizeVariantsSectionProps> = ({
  sizes,
  setSizes,
}) => {
  const [newSize, setNewSize] = useState('');

  const addSize = () => {
    if (newSize.trim() === '') {
      toast.error('Size is required');
      return;
    }
    
    setSizes(prev => [
      ...prev, 
      { 
        id: crypto.randomUUID(), 
        name: newSize 
      }
    ]);
    
    setNewSize('');
  };

  const removeSize = (id: string) => {
    setSizes(prev => prev.filter(size => size.id !== id));
  };

  return (
    <div className="space-y-3 pl-6 border-l-2 border-gray-200">
      <FormLabel>Sizes</FormLabel>
      <div className="flex items-center space-x-2">
        <Input
          placeholder="Size (e.g., S, M, L, XL, 38, 40)"
          value={newSize}
          onChange={(e) => setNewSize(e.target.value)}
          className="flex-1"
        />
        <Button type="button" onClick={addSize} size="icon" variant="outline">
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      
      {sizes.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {sizes.map((size) => (
            <div 
              key={size.id} 
              className="flex items-center bg-gray-100 rounded-full pl-3 pr-1 py-1 text-sm"
            >
              <span>{size.name}</span>
              <Button
                type="button"
                size="icon"
                variant="ghost"
                className="h-5 w-5 ml-1"
                onClick={() => removeSize(size.id)}
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SizeVariantsSection;
